import styled from 'styled-components';

import { Button } from '@main/pc-core-components/src/Button';
import { responsive, sp } from '@main/theme';

/**
 * The Download Button wrapper
 */
export const ButtonWrapper = styled(Button)`
  float: right;
  padding: 6px 10px 4px 10px;

  ${responsive.atLeastTablet} {
    padding: 7px 11px 5px 11px;
  }
`;

/**
 * The DataPreviewBlock wrapper
 */
export const DataPreviewBlockWrapper = styled.div`
  display: block;
  padding: ${sp(1.5)};
  margin: ${sp(0.4)} 0;
  background-color: ${({ theme }) => theme.colors.white};
`;
